<template >
  <div class="footer hidden-sm-and-down">
    <div class="col-lg-1 col-md-1 col-xs-1">
    <img class = "img-fix" :src="icono" width="100" height="50"/>
  </div>
 <div class="col-md-10 col-xs-12">
  <p class="p-new">Acreditación de Pregrado</p>
  <p class="p-new">Prorrectoría</p>
  <p class="p-new">Universidad de Santiago de Chile | Avenida las Sophoras #135 | Estación Central - Chile</p>
 </div>
</div>
</template>

<script>
import icono from "../../assets/LOGO USACH.png";

export default {
    data(){
      return{
        icono:icono
      }
    }
}
</script>

<style scoped>
.footer {
   position: fixed;
   z-index: 4;
   left: 0;
   bottom: 0;
   width: 100%;
   height: 50px;
   background-color: #475978;
   color: white;
   text-align: center;
   font-size: 11px;
}

.p-new{
      margin: 0 0 0px !important;
}
.img-fix{
  position: fixed;
  z-index: 15;
  
}
</style>




// WEBPACK FOOTER //
// src/components/template/Footer.vue